/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stop_ImpersonatingInputs */

const th_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หยุดสวมสิทธิ์`)
};

const en_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop impersonating`)
};

const ja_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理表示をやめる`)
};

const zh_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束身份切换`)
};

const es_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar de suplantar`)
};

const pt_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar de personificar`)
};

const id_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti menyamar`)
};

const fr_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter l’usurpation`)
};

const tl_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itigil ang pagpapanggap`)
};

const vi_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngừng mạo danh`)
};

const ko_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원래 계정으로 돌아가기`)
};

const de_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identitätswechsel beenden`)
};

const ru_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернуться к себе`)
};

const tr_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimliğe bürünmeyi bırak`)
};

const it_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smetti di impersonare`)
};

const pl_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przestań się wcielać`)
};

const uk_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повернутися до себе`)
};

const hi_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वापस अपने रूप में आएँ`)
};

const ar_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنهاء انتحال الهوية`)
};

const ms_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti menyamar`)
};

const bn_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিজের পরিচয়ে ফিরুন`)
};

const zh_tw2_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結束身分切換`)
};

const zh_hk2_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結束身分切換`)
};

const ur_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اپنی حیثیت پر واپس آئیں`)
};

const fa_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازگشت به خودتان`)
};

const sw_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acha kuingia kwa jina lake`)
};

const nl_stop_impersonating = /** @type {(inputs: Stop_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoppen met bekijken als`)
};

/**
* | output |
* | --- |
* | "Stop impersonating" |
*
* @param {Stop_ImpersonatingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const stop_impersonating = /** @type {((inputs?: Stop_ImpersonatingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stop_ImpersonatingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_stop_impersonating(inputs)
	if (locale === "ja") return ja_stop_impersonating(inputs)
	if (locale === "zh") return zh_stop_impersonating(inputs)
	if (locale === "es") return es_stop_impersonating(inputs)
	if (locale === "pt") return pt_stop_impersonating(inputs)
	if (locale === "id") return id_stop_impersonating(inputs)
	if (locale === "fr") return fr_stop_impersonating(inputs)
	if (locale === "tl") return tl_stop_impersonating(inputs)
	if (locale === "vi") return vi_stop_impersonating(inputs)
	if (locale === "ko") return ko_stop_impersonating(inputs)
	if (locale === "de") return de_stop_impersonating(inputs)
	if (locale === "ru") return ru_stop_impersonating(inputs)
	if (locale === "tr") return tr_stop_impersonating(inputs)
	if (locale === "it") return it_stop_impersonating(inputs)
	if (locale === "pl") return pl_stop_impersonating(inputs)
	if (locale === "uk") return uk_stop_impersonating(inputs)
	if (locale === "hi") return hi_stop_impersonating(inputs)
	if (locale === "ar") return ar_stop_impersonating(inputs)
	if (locale === "ms") return ms_stop_impersonating(inputs)
	if (locale === "bn") return bn_stop_impersonating(inputs)
	if (locale === "zh-TW") return zh_tw2_stop_impersonating(inputs)
	if (locale === "zh-HK") return zh_hk2_stop_impersonating(inputs)
	if (locale === "ur") return ur_stop_impersonating(inputs)
	if (locale === "fa") return fa_stop_impersonating(inputs)
	if (locale === "sw") return sw_stop_impersonating(inputs)
	if (locale === "nl") return nl_stop_impersonating(inputs)
	return en_stop_impersonating(inputs)
});